import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _asyncToGenerator from '@babel/runtime/helpers/esm/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { useRef, useState, useEffect } from 'react';
import createInstancePlugin from '@elliemae/ds-shared/createDataInstance/createInstancePlugin';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var registerStateHook = function registerStateHook(grid) {
  var _grid$props = grid.props,
      getData = _grid$props.getData,
      _grid$props$onInfinit = _grid$props.onInfiniteScrolling,
      onInfiniteScrolling = _grid$props$onInfinit === void 0 ? function () {
    return null;
  } : _grid$props$onInfinit,
      updateRows = grid.actions.updateRows;
  var loading = useRef(false);

  var addMoreData = function addMoreData() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    loading.current = false;
    updateRows(function (prevRows) {
      return prevRows.concat(data || []);
    });
  };

  var doLoadData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(currentRows) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loading.current = true;
              return _context.abrupt("return", Promise.resolve(getData(currentRows)).then(addMoreData));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function doLoadData(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var loadMoreData = function loadMoreData(currentRows) {
    onInfiniteScrolling(currentRows);
    if (loading.current || !getData) return;
    doLoadData(currentRows);
  };

  return {
    actions: {
      loadMoreData: loadMoreData
    }
  };
};

var getBodyProps = function getBodyProps(_ref2, grid) {
  _ref2.children;
      var props = _objectWithoutProperties(_ref2, ["children"]);

  var loadMoreData = grid.getInstance().actions.loadMoreData;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      bodyNode = _useState2[0],
      setBodyRef = _useState2[1];

  var prevScroll = useRef();
  prevScroll.current = 0;

  var handleBodyScroll = function handleBodyScroll(event, s) {
    var target = event.target;
    var scrollHeight = target.scrollHeight,
        scrollTop = target.scrollTop,
        offsetHeight = target.offsetHeight,
        scrollLeft = target.scrollLeft;

    var _grid$getInstance = grid.getInstance(),
        composedRows = _grid$getInstance.composedRows; // prevent horizontal scroll triggering infinite scrolling callbacks


    if (prevScroll.current !== scrollLeft) {
      prevScroll.current = scrollLeft;
      return;
    } // todo: clean this. Better approach using another component for the infinite scroll


    if (bodyNode !== target) return;

    if (scrollTop + offsetHeight >= scrollHeight - 1) {
      loadMoreData(composedRows);
    }
  };

  useEffect(function () {
    if (bodyNode) {
      bodyNode.addEventListener('scroll', handleBodyScroll);
    }

    return function () {
      if (bodyNode) {
        bodyNode.removeEventListener('scroll', handleBodyScroll);
      }
    };
  }, [bodyNode]);
  return _objectSpread(_objectSpread({}, props), {}, {
    listProps: {
      outerRef: setBodyRef
    }
  });
};

var InfiniteScrollPlugin = createInstancePlugin('infinite-scroll', {
  registerStateHook: registerStateHook,
  getBodyProps: getBodyProps
});

export { InfiniteScrollPlugin };
//# sourceMappingURL=InfiniteScrollPlugin.js.map
